module.exports = __webpack_public_path__ + "static/media/exampleRaster.19a7859f.tif";